.f{align-items:center;}